import { useEffect, useMemo } from 'react';
import {
	useIncomingMailExpiryStatus,
	DEFAULT_RESPONSE,
} from '@jira/router-resources__incoming-mail-server-expiry-status/src/useIncomingMailExpiryStatus.tsx';
import { BANNER_NAME, HEIGHT } from './bannerName.constants.tsx';
import { useBannerActions, useBannerState } from './useBannerState.tsx';

export const useBannerMailExpiry = (): {
	isEnabled: boolean;
	name: 'MAIL_EXPIRY_REMINDER';
	height: number;
} => {
	const { responseStatus, state } = useIncomingMailExpiryStatus();
	const { onStateFetch } = useBannerActions();
	const { isBannerShown } = useBannerState();

	useEffect(() => {
		if (responseStatus === 'error') {
			onStateFetch(DEFAULT_RESPONSE);
			return;
		}

		if (responseStatus === 'success') {
			onStateFetch(state);
		}
	}, [onStateFetch, responseStatus, state]);

	return useMemo(
		() => ({
			isEnabled: isBannerShown,
			name: BANNER_NAME,
			height: HEIGHT,
		}),
		[isBannerShown],
	);
};
